import { get } from 'lodash';
import React from 'react';
import { getLocalstorageToken } from 'src/context/AuthHelper';
import { ANTRAG_VERBUNDPARTNER } from 'src/lib/constants/componentsPath';
import { ANTRAG_TYP, ANTRAGBERECHTIGTE_TYP, KOSTEN_ARTEN, KOSTEN_POSITION } from 'src/lib/constants/constant';
import { getKostenHinweisStruc } from 'src/utils/ausgabenFinanzierungHelper';
import { isOrgaAbteilungEinerHochschule } from 'src/utils/helper';
import PersonalKostenAntragLoewe, { getFromStrucPersonalKostenAntragLoewe } from './PersonalKostenAntragLoewe';

// import Schemas
import Schema from 'src/lib/paths/antrag_FULL_Paths.json';
import { getVerbundPartnerName } from 'src/pages/private/online-antrag/application-helper-function/AppHelperfunctions';
const P = Schema.attributes;

export const GetPersonalKostenAntragLoewe = (application: any, hasCommentAusgabenUndFinanzierung?: boolean) => {
	const HinweisStruc = getKostenHinweisStruc(
		application,
		KOSTEN_POSITION.Ausgabe,
		KOSTEN_ARTEN.Personalkosten,
		ANTRAG_TYP.Antrag,
		hasCommentAusgabenUndFinanzierung,
	);

	const istHochschule = isOrgaAbteilungEinerHochschule(get(application, P.Antragstellende_Organisation.path, {}));

	const OrgaStruc = [
		{
			label: get(application, P.Antragstellende_Organisa_0074063902_licher_Name_Der_Organisation.path, `Antragsteller`),
			content: (
				<PersonalKostenAntragLoewe
					kostentraeger='Antragsteller'
					istHochschule={istHochschule}
					unternehmenId={get(getLocalstorageToken(), 'organisationId')}
					hasComment={hasCommentAusgabenUndFinanzierung}
				/>
			),
			formStruc: getFromStrucPersonalKostenAntragLoewe(application, istHochschule, get(getLocalstorageToken(), 'organisationId')),
			showError: false,
		},
	];

	const STRUC = get(application, P.Verbundpartner.path, []).map((ele: any, i: number) => {
		const isVpartnerHochschule =
			get(ele, `${ANTRAG_VERBUNDPARTNER.Antragberechtigt}.attributes.Allgemein_Typ`) === ANTRAGBERECHTIGTE_TYP.Forschungseinrichtung;

		return {
			label: `${getVerbundPartnerName(ele, i)}`,
			content: (
				<PersonalKostenAntragLoewe
					kostentraeger='Verbundpartner'
					istHochschule={isVpartnerHochschule}
					unternehmenId={get(ele, 'Verbundpartner.id')}
					hasComment={hasCommentAusgabenUndFinanzierung}
				/>
			),
			formStruc: getFromStrucPersonalKostenAntragLoewe(application, isVpartnerHochschule, get(ele, 'Verbundpartner.id')),
			showError: false,
		};
	});
	return [...HinweisStruc, ...OrgaStruc, ...STRUC];
};
